import { Badge, Text } from '@mantine/core';
import { PersonStatus } from '@dealstack/frontend/shared/components/ExpandablePersonCard/ExpandablePersonCard.types';

interface Props {
	status: PersonStatus;
}

export const SignerStatusPill = ({ status }: Props) => {
	return (
		<Badge
			miw="fit-content"
			size="sm"
			variant="outline"
			color={status.color}
			style={{
				padding: '0.25rem 0.5rem',
				border: `1px solid ${status.color}`,
			}}
		>
			<Text size="0.75rem" fw={400} lh="1rem" c={status.color}>
				{status.label}
			</Text>
		</Badge>
	);
};
